import {
    FormControl,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import { GadgetSortColumns, GadgetSortInitialValue, getGadgetSortFieldsByLabel } from "./GadgetModel";
import styles from "../css/Sorter.module.css";
import { faArrowUpZA, faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation, useNavigate } from "react-router-dom";

interface SorterIconProps {
    sortBy: string
}

export const SorterIcon = ({sortBy}: SorterIconProps) => {
    switch(sortBy) {
        case GadgetSortInitialValue[0].label:
            return (
                <FontAwesomeIcon icon={faClock} className={styles.sorterIcon}/>
            )
        case GadgetSortInitialValue[1].label:
            return (
                <FontAwesomeIcon icon={faArrowUpZA} className={styles.sorterIcon}/>
            )
        default:
            return (
                <FontAwesomeIcon icon={faArrowUpZA} className={styles.sorterIcon}/>
            )
    }
}

interface SorterProps {
    sortBy: GadgetSortColumns
}

export const Sorter = ({ sortBy }: SorterProps) => {
    const location = useLocation();
    const navigate = useNavigate();

    const setQueryParams = (sortModel: string) => {
        const q = new URLSearchParams(location.search);
        q.set("sort_by", sortModel.toString());
        navigate(location.pathname + "?" + q.toString());
    };

    const handleChange = (event: SelectChangeEvent) => {
        const value = event.target.value;
        const temp = getGadgetSortFieldsByLabel(value);
        setQueryParams(temp?.label || "");
    };

    return (
        <FormControl data-testid="gadget-sorter" size="small" sx={{ width: "100%" }}>
            <Select
                labelId="gadget-sorted"
                id="gadget-sorted-select"
                onChange={handleChange}
                className={styles.selectBox}
                value={sortBy.label}
            >
                {
                    Object.values(GadgetSortInitialValue)
                        .map(
                            (item) => 
                                <MenuItem 
                                    key={item.field}
                                    value={item.label}
                                    className={styles.selectBoxItem}
                                >
                                    <SorterIcon sortBy={item.label}/>
                                    {item.label}
                                </MenuItem>
                        )
                }
            </Select>
        </FormControl>
    )
}